import React from 'react';
import { Link } from 'react-router-dom';
import MarketingLayout from '../components/marketing/MarketingLayout';
import { FAQS, BRAND } from '../data/siteContent';

export default function FaqPage() {
  return (
    <MarketingLayout>
      <header className="mk-page-hero">
        <div className="mk-container">
          <span className="mk-eyebrow">FAQ</span>
          <h1>Frequently asked questions</h1>
          <p>Straight answers about {BRAND.name}, GED subjects, plans, AI tutoring, and the student portal.</p>
        </div>
      </header>

      <section className="mk-section">
        <div className="mk-container" style={{ maxWidth: 820 }}>
          <div className="mk-faq-stack">
            {FAQS.map((f) => (
              <details key={f.q} className="mk-faq-item" open={false}>
                <summary>{f.q}</summary>
                <p>{f.a}</p>
              </details>
            ))}
          </div>
          <div className="mk-center-cta" style={{ marginTop: 36 }}>
            <p style={{ color: 'var(--mk-body)', marginBottom: 12 }}>Still have a question?</p>
            <Link to="/contact" className="mk-btn mk-btn-primary">
              Contact an advisor
            </Link>
          </div>
        </div>
      </section>
    </MarketingLayout>
  );
}
